import { actionGenerator } from '../../utils/redux/actionGenerator';
import { ESearchResultsActionType } from './types';

export const openSearchResultsSidebar = actionGenerator<ESearchResultsActionType.SidebarOpened>(
  ESearchResultsActionType.SidebarOpened,
);
